import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import { searchState } from '../../recoil/state/search'

import { InputText } from 'mailup-web-components'

export const InputSearchString = ({ onChange, onEnter }) => {
  const intl = useIntl()
  const [{ searchText }, setSearch] = useRecoilState(searchState)

  const handleChange = e => {
    setSearch(prev => {
      onChange(e)
      return { ...prev, searchText: e.target.value }
    })
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && typeof onEnter === 'function') {
      onEnter()
    }
  }

  return (
    <InputText
      placeholder={intl.formatMessage({
        id: 'Load.EmailMessageList.SearchTextPlaceholder'
      })}
      value={searchText}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      className='test-searchInputText'
      data-mu-test='search__search-text'
    />
  )
}

InputSearchString.propTypes = {
  onChange: PropTypes.func
}
